import { extend } from 'vee-validate';

extend('alphabet', {
  validate: (value) => {
    return {
      required: true,
      // Only alphabets with space
      valid: /^[a-zA-Z ]+$/.test(value),
    };
  },
  computesRequired: true,
});
